export const feedFiltersCalendarZIndex = 1050;
export const feedTopBarMenuZIndex = 10;
export const feedTopBarNotificationsZIndex = 10;
export const confirmDialogZIndex = 1100;
export const toastZIndex = 1200;
